<template>
    <div>
        <h2>Home</h2>
        <UserPanel />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import UserPanel from '@/components/userPanel/UserPanel';

export default {
    name: 'Home',
    components: {
        UserPanel,
    },
    computed: {
        ...mapGetters([
            'oidcIsAuthenticated', // used to see if the user is logged in
        ]),
        hasAccess: function() {
            return this.oidcIsAuthenticated || this.$route.meta.isPublic;
        },
    },
};
</script>

<style>
body {
    margin: 0;
}
</style>
